import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import styles from './Cookies.module.scss';

const Cookies = ({ onClose }) => {
  const { cookie } = useStaticQuery(graphql`
    query {
      cookie: allFile(
        filter: {
          sourceInstanceName: { eq: "otherImages" }
          name: { eq: "cookie" }
        }
      ) {
        nodes {
          name
          publicURL
        }
      }
    }
  `);

  return (
    <div className={styles['cookie']}>
      <img src={cookie.nodes[0].publicURL} alt={'cookie'} />
      <Typography variant={'body2'}>
        We use cookies to improve user experience, and analyze website traffic.
        For these reasons, we may share your site usage data with our analytics
        partners. By continuing to the site, you consent to store on your device
        all the technologies described in our Cookie Policy. Please read our
        Terms of Use and Privacy Policy for full details.
      </Typography>
      <div className={styles['cookie__buttons-wrapper']}>
        <Button
          color={'primary'}
          href={'/cookies-policy'}
          variant={'contained'}
        >
          Learn more
        </Button>
        <Button color={'secondary'} variant={'contained'} onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default Cookies;
